const networks = {
  facebook: {
    url: (data) => `https://www.facebook.com/sharer/sharer.php?u=${data.url}`,
    width: 500, height: 550,
  },
  twitter: {
    url: (data) => `https://twitter.com/intent/tweet/?url=${data.url}`,
    width: 500, height: 300,
  },
  pinterest: {
    url: (data) => `https://www.pinterest.com/pin/create/button/?url=${data.url}&media=${data.image}`,
    width: 755, height: 600,
  },
};

document.addEventListener('click', (e) => {
  const el = e.target.closest('.js-social-share');
  if (!el) return;
  e.preventDefault();
  e.stopPropagation();

  const target = el.dataset.target;
  if (target) {
    document.querySelector(target)?.classList.toggle('is-active');
    el.classList.toggle('is-active');
    return;
  }

  const network = networks[el.dataset.network];
  if (!network) return;

  const url = network.url({ url: el.dataset.url, image: el.dataset.image });
  const left = screen.width / 2 - network.width / 2;
  const top = screen.height / 2 - network.height / 2;
  window.open(url, 'Share', `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${network.width},height=${network.height},top=${top},left=${left}`);
});
